/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigInputCompletionMinLevelsEffectiveAnyOf } from './taskEvaluationConfigInputCompletionMinLevelsEffectiveAnyOf';

export type TaskEvaluationConfigInputCompletionMinLevelsEffective =
  TaskEvaluationConfigInputCompletionMinLevelsEffectiveAnyOf | null;
